import { SkeletonImage } from 'skeleton-elements/vue';
export default SkeletonImage;